import {ControlBarActionItem} from 'common/query-builder/query-entry-section/constants';

import {nestedSavedMetricBannedActions} from './constants';

/**
 * Takes a list of control bar actions and if the behavior is nested in a saved
 * metric, filters out the banned actions.
 * @param controls
 * @param isNestedInSavedMetric Whether the behavior is nested in a saved metric.
 * @returns
 */
export function filterOutBannedActionsForEntriesNestedInSavedMetrics(
  controls: Array<ControlBarActionItem | null>,
  isNestedInSavedMetric: boolean,
): Array<ControlBarActionItem | null> {
  return controls.filter((control) => {
    if (isNestedInSavedMetric) {
      const valueAction = control?.value?.action;
      if (!valueAction) {
        return true;
      }
      const isBannedAction = nestedSavedMetricBannedActions.includes(valueAction);
      return !isBannedAction;
    }
    return true;
  });
}
